import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { onForgotPasswordDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import EMAIL_PATTERN from '../../utils/emailPattern'
import InlineError, { ariaErrorProps } from '../../generic/InlineError'
import { AuthFooter, AuthTitle } from '../../generic/AuthParts'
import '../../generic/RenderedField/styles.css'
import './styles.css'


export function ForgotPassword({ onSubmit, hideGlobalNav, showGlobalNav }) {
  // mode onChange validates as the user types, so the app's own error shows
  // instead of the browser's native bubble (the form is noValidate for that
  // same reason)
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isDirty }
  } = useForm({ mode: 'onChange' })

  useEffect(() => {
    hideGlobalNav()
    return () => showGlobalNav()
  }, [hideGlobalNav, showGlobalNav])

  return (
    <div id="ForgotPassword" className="auth-page">
      <div>
        <div className="logo">
          <Link to="/">
            <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
          </Link>
        </div>

        <div className="forgot-password-box auth-form-box">
          <AuthTitle>Reset your password</AuthTitle>
          <p className="forgot-password-intro">
            Enter your email and we&apos;ll send you a link to set a new
            password.
          </p>
          <form id="SignInForm" onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className={classnames('field', '-floating', { '-error': errors.email })}>
              <div className="field-container">
                <input
                  {...register('email', {
                    required: 'This field is required.',
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: 'Invalid email address.'
                    }
                  })}
                  type="email"
                  autoComplete="username"
                  placeholder=" "
                  id="forgot-password-email"
                  {...ariaErrorProps('forgot-password-email', errors.email)}
                />
                <label htmlFor="forgot-password-email">Email</label>
                <InlineError
                  id="forgot-password-email"
                  message={errors.email?.message}
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn -wide -orange"
              style={{ width: '100%' }}
              disabled={!isDirty || isSubmitting}
            >
              Send link
            </button>
          </form>

          <AuthFooter>
            <Link to="/login">Back to log in</Link>
          </AuthFooter>
        </div>
      </div>
    </div>
  )
}

ForgotPassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired
}

export default connect(
  null,
  dispatchSelector
)(ForgotPassword)
